<template>
    <v-app>
      <Navbar/>
      <v-content>
        <form @submit.prevent="addNewExpenseType">
          <v-card>
            <v-container grid-list-sm class="pa-4">
              <v-layout row wrap>
                <v-flex xs12 align-center justify-space-between>
                  <v-layout align-center>
                    <v-text-field
                      prepend-icon="format_size"
                      v-bind:placeholder="$t('Expense_type')"
                      required
                      v-model="expense_type"
                    ></v-text-field>
                  </v-layout>
                </v-flex>              
            
                <v-flex xs12>
                  <v-btn type="submit" block class="main_color" dark>{{ $t('Add')}} {{ $t('Expense Type')}}</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </form>
      </v-content>
    </v-app>
  </template>
  
  <script>
    import Navbar from '@/components/admin/navbar/Navbar'
    import db from '@/firebase/init'
    import moment from 'moment'
    export default {
      name:'AddExpenses',
      components:{
        Navbar
      },
      data(){
        return{         
          expense_type:'',
          timestamp:null,         
        }
      },
      methods:{
        addNewExpenseType(){  
          let ref = db.collection('expense_type');
            ref.add({          
              expense_type:this.expense_type,
              expense_date:moment().format('DD-MM-YYYY'),
              created_month:moment().format('MM-YYYY'),
              created_year:moment().format('YYYY'),
              timestamp:Date.now()
            })
          this.$router.push({ name: 'ExpenseType'})
        },
      },
      created(){
  
      },
      computed:{
        
      }
    }
  </script>
  
  <style>
  .primary--text {
      color: #F16D07 !important;
      caret-color: #F16D07 !important;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/admin/expenses/AddExpenseType.vue